module.exports = __webpack_public_path__ + "img/ic_pin_selected.0d311045.svg";